module.exports = __webpack_public_path__ + "img/vendorproof-logo@2x.4c1fa2a3.png";